import { AccountCreateModal } from '@accounts'
import { MODAL_SIZE } from '@constants'
import { NoAccountsIcon } from '@icons'
import { GlobalContext, tr } from 'mmfintech-commons'
import { Button } from 'mmfintech-portal-commons'
import { useContext } from 'react'
import { toast } from 'react-hot-toast'
import './NoAvailableAccounts.scss'

interface Props {
  currency: string
  reload: () => void
}

function NoAvailableAccounts({ currency, reload }: Props) {
  const { modalShow } = useContext(GlobalContext)

  function handleAddAccount() {
    modalShow({
      options: { closeOnClickOutside: false, size: MODAL_SIZE.AUTO, overflow: 'none' },
      content: (
        <AccountCreateModal
          filteredCurrencies={[currency]}
          onSuccess={(currencyCode: string) => {
            reload()
            toast.remove()
            toast.success(
              tr('FRONTEND.ACCOUNTS.SUCCESS_MESSAGE', '%CURRENCY% Account successfully added').replace(
                '%CURRENCY%',
                currencyCode
              )
            )
          }}
        />
      )
    })
  }

  return (
    <div className='no-available-accounts-wrapper'>
      <div className='left'>
        <NoAccountsIcon />
        <div>
          {tr('FRONTEND.ACCOUNTS.NO_ACCOUNTS_FOR_CURRENCY.TITLE', 'No Available Accounts in the currency you chose.')}
        </div>
      </div>
      <Button
        text={tr('FRONTEND.ACCOUNTS.CREATE.TITLE', 'Add New Account')}
        onClick={handleAddAccount}
        color='round-primary'
      />
    </div>
  )
}

export default NoAvailableAccounts
